import { createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { id: "list-courier-comission" }
const _hoisted_2 = { class: "flex w-full justify-between items-center" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h6", null, "Komisi Kurir", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: " font-medium text-right text-sm" }, "Total Komisi", -1)
const _hoisted_5 = { class: "font-bold text-right text-lg" }
const _hoisted_6 = { class: " inline-block" }
const _hoisted_7 = /*#__PURE__*/_createVNode("p", { class: "text-sm" }, "Filter Tanggal", -1)
const _hoisted_8 = { class: "p-col-12 block" }
const _hoisted_9 = { class: "btn-action w-full flex justify-end mt-5" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Clear Filter")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CardComissionHistory = _resolveComponent("CardComissionHistory")
  const _component_Paginator = _resolveComponent("Paginator")
  const _component_Card = _resolveComponent("Card")
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_Button = _resolveComponent("Button")
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Card, { class: "h-full" }, {
      title: _withCtx(() => [
        _createVNode("div", null, [
          _createVNode("div", _hoisted_2, [
            _hoisted_3,
            _createVNode("div", null, [
              _hoisted_4,
              _createVNode("p", _hoisted_5, _toDisplayString(`Rp. ${new Number(_ctx.dataBeratKomisiResi?.Komisi).toLocaleString("id-ID")}`), 1)
            ])
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode("div", {
              class: ["btn-custom-outline flex cursor-pointer gap-2 px-2 py-1 items-center", _ctx.isUsingFilter ? 'primary-color' : 'grey-color'],
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDateFilter($event)))
            }, [
              _hoisted_7
            ], 2)
          ])
        ])
      ]),
      content: _withCtx(() => [
        _createVNode("div", null, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data, (slot, index) => {
            return (_openBlock(), _createBlock(_component_CardComissionHistory, {
              data: slot,
              key: index
            }, null, 8, ["data"]))
          }), 128))
        ])
      ]),
      footer: _withCtx(() => [
        (_ctx.data.length > 0)
          ? (_openBlock(), _createBlock(_component_Paginator, {
              key: 0,
              rows: _ctx.filters.top,
              totalRecords: _ctx.totalRecords,
              onPage: _ctx.onPage
            }, null, 8, ["rows", "totalRecords", "onPage"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_OverlayPanel, {
      ref: "dateOp",
      id: "filter_overlay_panel",
      class: "p-5"
    }, {
      default: _withCtx(() => [
        _createVNode("span", _hoisted_8, [
          _createVNode(_component_Calendar, {
            modelValue: _ctx.dateFilter,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.dateFilter = $event)),
            inline: true,
            showWeek: true,
            selectionMode: "range"
          }, null, 8, ["modelValue"]),
          _createVNode("div", _hoisted_9, [
            (_ctx.dateFilter)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  label: "Filter",
                  class: "font-semibold p-button-sm btn-primary px-10 mr-2",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.saveFilterDate()))
                }))
              : _createCommentVNode("", true),
            (_ctx.dateFilter)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  class: "btn-secondary text-black p-button-sm px-10 py-1",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.clearFilterDate()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 512)
  ]))
}